module.exports = __webpack_public_path__ + "static/default-9a344a6c7e456a104fac9b9c94b4c530.jpg";